module.exports = __webpack_public_path__ + "static/media/studentAnswerBg.f62219c3.svg";